export default __webpack_public_path__ + "static/media/Spirit of Jovus.f3a533f3.jpg";